import * as React from 'react';
import { HookPaginationProps } from '../../../../common/hook/usePaginationHook';
import SchemaForm from '../../../../common/SchemaForm';
import { schemaUserForm } from './schema';

interface Props {
  hookPagination: HookPaginationProps;
  onAddNew: () => void;
  pagin?: React.ReactNode;
}

const SearchAccountAdmin: React.FunctionComponent<Props> = (props) => {
  const { hookPagination, onAddNew, pagin } = props;
  const { params, setParams } = hookPagination;
  return (
    <SchemaForm
      schema={schemaUserForm}
      onSubmit={setParams}
      formData={params}
      hideSubmitButton
      onAddNew={onAddNew}
      pagin={pagin}
    />
  );
};

export default SearchAccountAdmin;
